export function showCancelledPayment(){
    return function(dispatch){
        dispatch({type: 'SHOW_CANCELLED_PAYMENT_MESSAGE',})
    }
}

export function showErrorOnPayment(){
    return function(dispatch){
        dispatch({type: 'SHOW_ERROR_ON_PAYMENT_MESSAGE',})
    }
}

export function clearCartMessages(){
    return function(dispatch){
        dispatch({type: 'CLEAR_CART_MESSAGES',})
    }
}

export function showInvalidTransactionError() {
  return function(dispatch) {
    dispatch({ type: 'SHOW_INVALID_TRANSACTION_ERROR'})
  }
}

export function updateShipmentLocations(location, types, shipment_location_details) {
  return function(dispatch) {
      if (types === "origin"){
		    dispatch({type: 'CLEAR_CHECKOUT_FULFILLED',});
        dispatch({type: 'UPDATE_SHIPMENT_LOCATION_DETAILS',
        origin: location,
        destination: shipment_location_details.destination})
      }else{
        dispatch({type: 'UPDATE_SHIPMENT_LOCATION_DETAILS',
        origin: shipment_location_details.origin,
        destination: location})
      }  
  }
}


/** WEBPACK FOOTER **
 ** ./src/actions/CartAction.js
 **/